export default __webpack_public_path__ + "static/media/page-produit.66e40606.jpg";